import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";
import PageShell from "../layout/PageShell";
import PageHead from "../layout/PageHead";

const Permission = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);
  return (
    <PageShell><PageHead title="No permission" /><div className="list">
      <div className="listContainer">
        <div className="not-found">
          <h2>Unauthorized</h2>
          <br />
          <p>You do not have access to the requested page.</p>
          <div className="flexGrow">
            <button onClick={goBack}>Go Back</button>
          </div>
        </div>
      </div>
    </div></PageShell>
  );
};

export default Permission;
